import { action } from 'easy-peasy';
import { IResetCurrentSosRequestAction } from '../types';

const ISetSosRequestsAction: IResetCurrentSosRequestAction = action(state => {
  state.current = null;
});

export default ISetSosRequestsAction;
